import { MENU, IMAGES } from "@/lib/data";
import { Reveal, MaskedLines } from "./motion";

export default function MenuSection() {
  return (
    <section id="menu" data-testid="menu-section" className="relative bg-sand py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-16">
          <div>
            <span className="text-xs tracking-[0.25em] uppercase font-sans font-semibold text-terracotta">
              La nostra cucina
            </span>
            <h2 className="mt-5 font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[0.9] text-charcoal">
              <MaskedLines lines={["Il menu"]} />
              <MaskedLines lines={["di mare"]} lineClassName="italic text-terracotta" delay={0.1} />
            </h2>
          </div>
          <p className="font-sans text-pebble max-w-xs text-sm leading-relaxed">
            Le proposte cambiano con la freschezza del giorno. Pane, coperto e
            servizio € 2,5.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Menu columns */}
          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-x-14 gap-y-14">
            {MENU.map((cat, ci) => (
              <Reveal key={cat.id} delay={ci * 0.06}>
                <div className="flex items-center gap-4 mb-6">
                  <h3 className="font-serif text-2xl sm:text-3xl text-charcoal">{cat.title}</h3>
                  <span className="h-px flex-1 bg-charcoal/15" />
                </div>
                <ul className="flex flex-col gap-5">
                  {cat.items.map((it) => (
                    <li key={it.name} className="group">
                      <div className="flex items-baseline gap-3">
                        <span className="font-serif text-lg sm:text-xl text-charcoal group-hover:text-terracotta transition-colors duration-300">
                          {it.name}
                        </span>
                        <span className="flex-1 border-b border-dotted border-charcoal/25 translate-y-[-3px]" />
                        <span className="font-sans font-semibold text-terracotta text-lg">€ {it.price}</span>
                      </div>
                      {it.desc && (
                        <p className="font-sans text-sm text-pebble mt-1 max-w-sm">{it.desc}</p>
                      )}
                    </li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </div>

          {/* Menu card photo */}
          <div className="lg:col-span-4">
            <Reveal delay={0.1} className="lg:sticky lg:top-24">
              <div className="relative">
                <div className="absolute -inset-3 bg-olive/10 rounded-sm -rotate-2" />
                <img
                  src={IMAGES.menuCard}
                  alt="Il menu cartaceo del Bar Ristorante Gabri"
                  className="relative w-full aspect-[9/16] object-cover rounded-sm shadow-xl"
                  loading="lazy"
                />
              </div>
              <p className="mt-5 font-serif italic text-pebble text-center text-lg">
                «Variano di giorno in giorno… chiedere al cameriere»
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
